import Image_aus from "../lastimages/nations/img_aus.png";
import Image_bali from "../lastimages/nations/img_bali.jpg";
import Image_cancun from "../lastimages/nations/img_cancun.jpg";
import Image_dubai from "../lastimages/nations/img_dubai.jpg";
import Image_guam from "../lastimages/nations/img_guam.jpg";
import Image_hawaii from "../lastimages/nations/img_hawaii.jpg";
import Image_maldives from "../lastimages/nations/img_maldives.jpg";
import Image_morisus from "../lastimages/nations/img_morisus.png";
import Image_nhatrang from "../lastimages/nations/img_nhatrang.jpg";
import Image_phuket from "../lastimages/nations/img_phuket.jpg";
import Image_france from "../lastimages/nations/img_france.jpeg";
import hotel_01 from "../lastimages/hotels/hotel_01.png";
import hotel_02 from "../lastimages/hotels/hotel_02.png";
import hotel_03 from "../lastimages/hotels/hotel_03.png";
import hotel_04 from "../lastimages/hotels/hotel_04.png";
import hotel_05 from "../lastimages/hotels/hotel_05.png";
import hotel_06 from "../lastimages/hotels/hotel_06.png";
import hotel_07 from "../lastimages/hotels/hotel_07.png";
import hotel_08 from "../lastimages/hotels/hotel_08.png";
import hotel_09 from "../lastimages/hotels/hotel_09.png";
import hotel_10 from "../lastimages/hotels/hotel_10.png";
import hotel_11 from "../lastimages/hotels/hotel_11.png";
import hotel_12 from "../lastimages/hotels/hotel_12.png";
import hotel_13 from "../lastimages/hotels/hotel_13.png";
import hotel_14 from "../lastimages/hotels/hotel_14.png";


export { Image_aus, Image_bali, Image_cancun, Image_dubai, Image_france, Image_guam,
        Image_hawaii, Image_maldives, Image_morisus, Image_nhatrang, Image_phuket,
        hotel_01, hotel_02, hotel_03, hotel_04, hotel_05, hotel_06, hotel_07,
        hotel_08, hotel_09, hotel_10, hotel_11, hotel_12, hotel_13, hotel_14  };


export default { Image_aus, Image_bali, Image_cancun, Image_dubai, Image_france, Image_guam,
        Image_hawaii, Image_maldives, Image_morisus, Image_nhatrang, Image_phuket,
        hotel_01, hotel_02, hotel_03, hotel_04, hotel_05, hotel_06, hotel_07,
        hotel_08, hotel_09, hotel_10, hotel_11, hotel_12, hotel_13, hotel_14 };
